module.exports = __webpack_public_path__ + "img/629.Hot_drink_cups.b61bae19.svg";